var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { CardRarity } from '@cta-portal/webapp-common/lib/api/schema';
import React from 'react';
import styled from 'styled-components';
export default function RarityCheckbox(_a) {
    var value = _a.value, rarity = _a.rarity, hidden = _a.hidden, noneSelected = _a.noneSelected, onChange = _a.onChange;
    function getRarityContent() {
        switch (rarity) {
            case CardRarity.MYTHIC: {
                return 'M';
            }
            case CardRarity.ULTRA_RARE: {
                return 'UR';
            }
            case CardRarity.RARE: {
                return 'R';
            }
            case CardRarity.UNCOMMON: {
                return 'U';
            }
            case CardRarity.COMMON: {
                return 'C';
            }
            case CardRarity.UNIQUE: {
                return 'U';
            }
            case CardRarity.EXCLUSIVE: {
                return 'E';
            }
            case CardRarity.SPECIAL_RARE: {
                return 'SR';
            }
            default: {
                return '';
            }
        }
    }
    function getBackgroundColor() {
        switch (rarity) {
            case CardRarity.MYTHIC: {
                return '#eaba50';
            }
            case CardRarity.ULTRA_RARE: {
                return '#d353e2';
            }
            case CardRarity.RARE: {
                return '#00bdff';
            }
            case CardRarity.UNCOMMON: {
                return '#5fd86e';
            }
            case CardRarity.COMMON: {
                return '#c0c0c0';
            }
            case CardRarity.UNIQUE: {
                return 'linear-gradient(135deg, #9835c0 5%, #09b4fb 28%, #54d57e 51%, #f59100 75%, #c70100 96%)';
            }
            case CardRarity.EXCLUSIVE: {
                return 'linear-gradient(135deg, #feb001 5%, #8e82fe 51%, #f45fa2 96%)';
            }
            case CardRarity.SPECIAL_RARE: {
                return 'linear-gradient(to bottom, #d154e2, #02bbfe)';
            }
            default: {
                return 'none';
            }
        }
    }
    return (_jsx(Container, { background: getBackgroundColor(), checked: value, hidden: hidden, noneSelected: noneSelected, onClick: onChange, children: _jsx("button", { children: _jsx("div", { className: "button-overlay-1", children: _jsx("div", { className: "button-overlay-2", children: _jsx("div", { children: _jsx("p", { children: getRarityContent() }) }) }) }) }) }));
}
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  cursor: pointer;\n  flex-direction: row;\n  height: 48px;\n  justify-content: center;\n  opacity: ", ";\n  width: 48px;\n\n  &:hover {\n    opacity: ", ";\n  }\n\n  & > button {\n    background-image: ", ";\n    border-radius: 50%;\n    box-shadow: ", ";\n    height: 100%;\n    padding: 2px;\n    width: 100%;\n\n    .button-overlay-1 {\n      border-radius: 50%;\n      height: 100%;\n      padding: 2px;\n      width: 100%;\n\n      .button-overlay-2 {\n        background: ", ";\n        border-radius: 50%;\n        height: 100%;\n        padding: 2px;\n        width: 100%;\n\n        & > div {\n          align-items: center;\n          background: ", ";\n          border-radius: 50%;\n          display: flex;\n          flex-direction: column;\n          height: 100%;\n          justify-content: center;\n          overflow: hidden;\n          width: 100%;\n\n          & > p {\n            font-size: 20px;\n            font-weight: 700;\n          }\n        }\n      }\n    }\n  }\n"], ["\n  align-items: center;\n  display: flex;\n  cursor: pointer;\n  flex-direction: row;\n  height: 48px;\n  justify-content: center;\n  opacity: ", ";\n  width: 48px;\n\n  &:hover {\n    opacity: ", ";\n  }\n\n  & > button {\n    background-image: ", ";\n    border-radius: 50%;\n    box-shadow: ", ";\n    height: 100%;\n    padding: 2px;\n    width: 100%;\n\n    .button-overlay-1 {\n      border-radius: 50%;\n      height: 100%;\n      padding: 2px;\n      width: 100%;\n\n      .button-overlay-2 {\n        background: ", ";\n        border-radius: 50%;\n        height: 100%;\n        padding: 2px;\n        width: 100%;\n\n        & > div {\n          align-items: center;\n          background: ", ";\n          border-radius: 50%;\n          display: flex;\n          flex-direction: column;\n          height: 100%;\n          justify-content: center;\n          overflow: hidden;\n          width: 100%;\n\n          & > p {\n            font-size: 20px;\n            font-weight: 700;\n          }\n        }\n      }\n    }\n  }\n"])), function (_a) {
    var hidden = _a.hidden, noneSelected = _a.noneSelected;
    return (hidden || noneSelected ? '0.7' : '1');
}, function (_a) {
    var hidden = _a.hidden, noneSelected = _a.noneSelected;
    return (hidden || noneSelected ? '0.5' : '0.8');
}, function (_a) {
    var checked = _a.checked;
    return checked ? 'linear-gradient(to right, #c1a16c, #e7c9a2 50%, #c1a16c)' : 'none';
}, function (_a) {
    var checked = _a.checked;
    return (checked ? '0 0 6px 0 #ffb800' : 'none');
}, function (_a) {
    var background = _a.background;
    return background;
}, function (_a) {
    var checked = _a.checked, theme = _a.theme;
    return checked
        ? 'linear-gradient(to bottom, #423686 1%, #171940 46%, #1e1e48 64%, #312b60 92%)'
        : theme.palette.layoutNeutral;
});
var templateObject_1;
